'use client';

import { c as _c } from "react/compiler-runtime";
import type { BankFundingMethod, FundingMethod, UnavailableBankFundingMethod } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { useFundingBankSubtitles } from '../shared/funding-method-presentation';
import { FundingMethodRow } from './funding-method-row';
export function FundingBankMethods(t0) {
  const $ = _c(44);
  const {
    methods,
    selectableMethods,
    unavailableReasons,
    onSelect
  } = t0;
  const t = useTranslations("onramp");
  const bankSubtitles = useFundingBankSubtitles();
  let t1;
  if ($[0] !== t) {
    t1 = t("bank_unavailable.provider_unavailable");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("bank_unavailable.currency_unavailable");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("bank_unavailable.region_unavailable");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("bank_unavailable.asset_unavailable");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("bank_unavailable.execution_unavailable");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("bank_unavailable.connection_required");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = {
      provider_unavailable: t1,
      currency_unavailable: t2,
      region_unavailable: t3,
      asset_unavailable: t4,
      execution_unavailable: t5,
      connection_required: t6
    };
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const bankUnavailableReasons = t7;
  let t8;
  if ($[19] !== t) {
    t8 = t("bank_transfers");
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("bank_transfers");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <h3 className="text-micro font-medium uppercase tracking-wide text-foreground-secondary">{t9}</h3>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== bankSubtitles || $[26] !== bankUnavailableReasons || $[27] !== methods || $[28] !== onSelect || $[29] !== selectableMethods || $[30] !== unavailableReasons) {
    let t12;
    if ($[32] !== bankSubtitles || $[33] !== bankUnavailableReasons || $[34] !== onSelect || $[35] !== selectableMethods || $[36] !== unavailableReasons) {
      t12 = method => <FundingMethodRow key={method} method={method} subtitle={selectableMethods.has(method) ? bankSubtitles[method] : bankUnavailableReasons[unavailableReasons.get(method) ?? "provider_unavailable"]} onSelect={selectableMethods.has(method) ? onSelect : undefined} />;
      $[32] = bankSubtitles;
      $[33] = bankUnavailableReasons;
      $[34] = onSelect;
      $[35] = selectableMethods;
      $[36] = unavailableReasons;
      $[37] = t12;
    } else {
      t12 = $[37];
    }
    t11 = methods.map(t12);
    $[25] = bankSubtitles;
    $[26] = bankUnavailableReasons;
    $[27] = methods;
    $[28] = onSelect;
    $[29] = selectableMethods;
    $[30] = unavailableReasons;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[38] !== t11) {
    t12 = <div className="overflow-hidden rounded-control bg-background-tertiary">{t11}</div>;
    $[38] = t11;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t10 || $[41] !== t12 || $[42] !== t8) {
    t13 = <section className="flex flex-col gap-2" aria-label={t8}>{t10}{t12}</section>;
    $[40] = t10;
    $[41] = t12;
    $[42] = t8;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  return t13;
}